export default __webpack_public_path__ + "static/media/flyer.57365e42.jpg";